$(function(){
  check_currency_switcher();
  var switcher = setInterval(function(){
       check_currency_switcher();
   }, 1);
    function check_currency_switcher(){
        if($('.transcy-switcher-manual').html().length){
          clearInterval(switcher);
          var main_select = $('.transcy-select-language-selected .transcy-locale-name');
        main_select.text(main_select.text().slice(0, 3));
         var child_options = $('.transcy-select-items');
          child_options.find('div[data-href="null"]').each(function(){
            var child_item = $(this).find('.transcy-locale-name');
            child_item.text(child_item.text().slice(0,3))
          });
    	}
    }
});

